import React from 'react'
import { css } from '@emotion/core'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'
import {
  createSelfCheckinBaseStyle,
  createSelfCheckinResponsiveStyle,
  FrontTabletResponsiveToken,
} from '@/utils/front-tablet-responsive-style'

type ComponentProps = {
  error?: boolean
  maxWidth?: number
} & React.ComponentPropsWithoutRef<'select'>

const FrontTabletSelectBox = React.forwardRef<HTMLSelectElement, ComponentProps>(({ error, maxWidth, ...props }, ref) => {
  return <select {...props} ref={ref} css={[selectBoxStyle, maxWidth && css({ maxWidth }), error && errorSelectStyle]} />
})
FrontTabletSelectBox.displayName = 'FrontTabletSelectBox'
export { FrontTabletSelectBox }

const selectBoxStyle = css(
  {
    '-webkit-appearance': 'none',
    width: '100%',
    height: 61,
    color: '#272727',
    fontSize: FrontTabletFontSize.formInput,
    border: '1px solid #CCCCCC',
    borderRadius: 40,
    padding: '14px 35px',
    appearance: 'none',
    backgroundImage: `url(${require('@/static/images/arrow_down_yellow.svg')})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '95% center',
    backgroundColor: '#FFFFFF',
    backgroundSize: 14,
    display: 'block',
  },
  createSelfCheckinBaseStyle({ fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape11 }),
  createSelfCheckinResponsiveStyle({
    landscape13: {
      fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape13,
      lineHeight: 1,
    },
  }),
)

const errorSelectStyle = css({
  borderColor: '#ff2700 !important',
})
